import React from 'react';
import { Image } from '@chakra-ui/react';
import footerLogo from '@/assets/gigabet/images/footer/logoFooter.png';

export default function index() {
  return <Image src={footerLogo} maxW="200px" maxH="45px" />;
}
